import React    from 'react';
import filesize from 'filesize'

import TimeAgo              from 'react-timeago';
import ruStrings            from 'react-timeago/lib/language-strings/ru'
import buildFormatter       from 'react-timeago/lib/formatters/buildFormatter'

import API                  from './server_api'

const formatter = buildFormatter(ruStrings);


function FileUploading(props) {
    return (
        <div className="d-flex w-100">
            <div className="align-self-center mx-3">
                <img src="img/cloud-upload-gray.svg" height="50" alt="upload" />
            </div>
            <div className="d-flex w-100 flex-column flex-md-row align-items-md-center">
                <h4 className="text-dark my-0 mr-3 text-break text-muted">
                    {props.name}
                </h4>
                <div className="progress flex-grow-1 mr-2" style={{height: "22px"}}>
                    <div className="progress-bar progress-bar-striped progress-bar-animated" 
                        style={{width: props.progress+"%"}}>
                        {Math.round(props.progress) + "%"}
                    </div>
                </div>
            </div>
            <button type="button" 
                className="close mr-2" 
                onClick={props.callback} 
                id={props.index}>
                    &times;
            </button>
        </div>
    );
}

function FileQueued(props) {
    return (
        <div className="d-flex w-100">
            <div className="align-self-center mx-3">
                <img src="img/cloud-upload-light.svg" height="50" alt="upload" />
            </div>
            <div className="d-flex w-100 flex-column flex-md-row align-items-md-center">
                <h4 className="text-dark my-0 mr-3 text-break text-muted">
                    {props.name}
                </h4>
                <small className="flex-grow-1 mr-2 text-secondary">
                    В очереди на загрузку
                </small>
            </div>
            <button type="button" 
                className="close mr-2" 
                onClick={props.callback} 
                id={props.index}>
                    &times;
            </button>
        </div>
    );
}


function FileError(props) {
    return (
        <div className="d-flex w-100">
            <div className="align-self-center mx-3">
                <img src="img/error.svg" height="50" alt="upload" />
            </div>
            <div className="d-flex w-100 flex-column flex-md-row align-items-md-center">
                <h4 className="text-dark my-0 mr-3 text-break text-muted">
                    {props.name}
                </h4>
                <small className="flex-grow-1 mr-2 text-secondary">
                    {props.error_text}
                </small>
            </div>
            <button type="button" 
                className="close mr-2" 
                onClick={props.callback} 
                id={props.index}>
                    &times;
            </button>
        </div>
    );
}


function FileNormal(props) {
    return (
        <div className="d-flex w-100">
            <a download href={API.fileDownloadURL(props.id, props.token)} className="align-self-center mx-3">
                <img src="img/cloud-download.svg" height="50" alt="download" />
            </a>
            <div className="d-flex w-100 flex-column flex-md-row align-items-md-center">
                <a download ref={props.saveRef} href={API.fileDownloadURL(props.id, props.token)} className="flex-grow-1 text-dark">
                    <h4 className="my-0 mr-2 text-break">
                        {props.name}
                    </h4>
                </a>
                <div className="d-flex flex-column flex-md-row">
                    <small className="mx-md-2 mx-0 text-body text-break">
                        { filesize(props.size) }
                    </small> 
                    <small className="mx-md-2 mx-0 text-secondary text-break">
                        <TimeAgo date={props.uploaded} formatter={formatter} />
                    </small> 
                    <small className="mr-md-2 mx-0 text-secondary text-break">
                        {props.user}
                    </small>
                </div>
            </div>
        </div>
    );
}

export default function File(props) {
    let file;
    if (props.queued)
        file = FileQueued(props);
    else if (props.uploading)
        file = FileUploading(props);
    else if (props.error)
        file = FileError(props);
    else
        file = FileNormal(props);
    return (
    <div key={props.index} className="list-group-item p-1">
        {file}
    </div>);
}
